export default {
  'Teklif Formu': 'نموذج عرض السعر',
  'Kayıtlı Teklifler': 'العروض المحفوظة',
  'Kullanıcı Adı': 'اسم المستخدم',
  'Şifre': 'كلمة المرور',
  'Giriş Yap': 'تسجيل الدخول',
  'Çıkış Yap': 'تسجيل الخروج',
  'KDV Oranı': 'معدل الضريبة على القيمة المضافة',
  'Teklif Durumu': 'حالة العرض',
  'Kaydet': 'حفظ',
  'PDF Önizleme': 'معاينة PDF',
  'PDF\'ye Aktar': 'تصدير إلى PDF',
  'E-posta ile Gönder': 'إرسال عبر البريد الإلكتروني',
  'Alıcı': 'المستلم',
  'Tarih': 'التاريخ',
  'Genel Toplam': 'المجموع الكلي',
  'Not': 'ملاحظة',
  'KDV': 'الضريبة على القيمة المضافة',
  'Alt Toplam': 'المجموع الفرعي',
  'Açıklama': 'الوصف',
  'Ürün Adı': 'اسم المنتج',
  'SUT Kodu': 'رمز SUT',
  'Birim Alış Fiyatı': 'سعر الوحدة',
  'Sipariş Adedi': 'كمية الطلب',
  'Promosyon Ürün': 'منتج ترويجي',
  'Toplam Adet': 'الكمية الإجمالية',
  'Sipariş Tutarı': 'مبلغ الطلب',
  'Durum': 'الحالة',
  'Kabul Edildi': 'مقبول',
  'Reddedildi': 'مرفوض',
  'Gönderildi': 'مرسل',
  'Taslak': 'مسودة',
  'Yurtiçi': 'محلي',
  'Yurtdışı': 'دولي',
  'Sipariş Oluştur': 'إنشاء طلب',
  'Ürün Sıralaması': 'ترتيب المنتجات',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'المنتجات مرتبة حسب الشعبية والأهمية',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'منتجات أمراض القلب وجراحة الأوعية الدموية معروضة كأولوية',
  'Ürün adı, açıklama veya barkod ile ara...': 'البحث باسم المنتج أو الوصف أو الباركود...',
  'Tüm Kategoriler': 'جميع الفئات',
  'Kutu görünüm': 'عرض الشبكة',
  'Liste görünüm': 'عرض القائمة',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'لم يتم العثور على منتجات تطابق معايير البحث',
  'Ürün Adı Yok': 'لا يوجد اسم منتج',
  'Kategori Yok': 'لا توجد فئة',
  'Açıklama yok': 'لا يوجد وصف',
  'Firma Bilgilerini Doldurun': 'ملء معلومات الشركة',
  'Sepete Ekle': 'إضافة إلى السلة',
  'Firma Bilgileri': 'معلومات الشركة',
  'Ülke Seçimi': 'اختيار البلد',
  'Türkiye': 'تركيا',
  'Almanya': 'ألمانيا',
  'ABD': 'الولايات المتحدة',
  'Firma Ünvanı': 'اسم الشركة',
  'Vergi Dairesi': 'مصلحة الضرائب',
  'Vergi Numarası': 'الرقم الضريبي',
  'Adres': 'العنوان',
  'Şehir': 'المدينة',
  'Şehir Seçimi': 'اختيار المدينة',
  'Şehir Seçiniz': 'اختر المدينة',
  'Şehir adı ara...': 'البحث عن اسم المدينة...',
  'Aradığınız şehir bulunamadı': 'لم يتم العثور على المدينة',
  'Bu ülke için şehir verisi bulunamadı': 'لا توجد بيانات مدينة لهذا البلد',
  'şehir bulundu': 'تم العثور على {{count}} مدينة',
  'Yetkili': 'الشخص المفوض',
  'Telefon': 'الهاتف',
  'Email': 'البريد الإلكتروني',
  'Bilgileri İlet': 'إرسال المعلومات',
  'Lütfen eksik alanları doldurun': 'يرجى ملء الحقول المفقودة',
  'Firma kaydedilemedi': 'لم يتم حفظ الشركة',
  'Firma bilgileri başarıyla iletildi': 'تم إرسال معلومات الشركة بنجاح',
  'Firma Ünvanı:': 'اسم الشركة:',
  'Yetkili Kişi:': 'الشخص المفوض:',
  'Sepetiniz': 'سلتك',
  'Sepetiniz boş': 'سلتك فارغة',
  'adet': 'قطعة',
  'Düzenle': 'تعديل',
  'Kaldır': 'إزالة',
  'Siparişi Tamamla': 'إكمال الطلب',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'يرجى إرسال معلومات شركتك الكاملة أولاً',
  'Sipariş başarıyla kaydedildi': 'تم حفظ الطلب بنجاح',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'تم إرسال رسالة الترحيب ورابط الوصول إلى بريدك الإلكتروني',
  'Link 3 gün geçerlidir': 'الرابط صالح لمدة 3 أيام',
  'Sipariş kaydedilemedi': 'لم يتم حفظ الطلب',
  'Firma Bilgileri Gerekli': 'معلومات الشركة مطلوبة',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'املأ معلومات الشركة أولاً لإضافة إلى السلة',
  'Önce Bilgileri Doldurun': 'املأ المعلومات أولاً',
  'Uyarı': 'تحذير',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'يجب عليك ملء معلومات الشركة أولاً لإضافة إلى السلة',
  'SUT Kütüphanesi Tanımı': 'تعريف مكتبة SUT',
  'SUT Kodu:': 'رمز SUT:',
  'Standart': 'قياسي',
  'Açıklama (isteğe bağlı)': 'الوصف (اختياري)',
  'Partner Ol': 'كن شريكاً',
  'Partner başvuru popup açılacak': 'سيتم فتح نافذة طلب الشريك',
  'Dil': 'اللغة',
  'E-posta': 'البريد الإلكتروني',
  'E-Posta': 'البريد الإلكتروني',
  'Şifre': 'كلمة المرور',
  'Şifremi Unuttum': 'نسيت كلمة المرور',
  'Giriş yapılıyor...': 'جاري تسجيل الدخول...',
  'E-posta veya şifre hatalı': 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  'Şifre sıfırlama e-postası gönderildi': 'تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور',
  'E-posta gönderilemedi': 'لم يتم إرسال البريد الإلكتروني',
  'Üye Ol': 'تسجيل',
  'Üye Değil Misiniz?': 'لست عضواً؟',
  'Şimdi Üye Ol': 'سجل الآن',
  'Misafir Kullanıcı': 'مستخدم ضيف',
  'Hızlı Sipariş': 'طلب سريع',
  'Misafir Olarak Sipariş Verin': 'اطلب كضيف',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'اختر منتجاتك بسرعة وأنشئ طلبك دون تسجيل الدخول',
  'Giriş yapmadan sipariş oluşturun': 'أنشئ طلباً دون تسجيل الدخول',
  'Anında Erişim': 'وصول فوري',
  'Tüm ürünlere anında erişim': 'وصول فوري لجميع المنتجات',
  'Güvenli İşlem': 'معاملة آمنة',
  'SSL korumalı güvenli sipariş': 'طلب آمن محمي بـ SSL',
  'Misafir Olarak Sipariş Oluştur': 'أنشئ طلباً كضيف',
  'İpucu:': 'نصيحة:',
  'Daha fazla özellik için üye olun': 'سجل للحصول على المزيد من الميزات',
  'Ücretsiz': 'مجاني',
  'Hızlı': 'سريع',
  'Güvenli': 'آمن',
  'bayilikSozlesme': 'لقد قرأت وأوافق على شروط وأحكام شراكة INVAMED.',
  'geri': 'رجوع',
  'basvuruGonder': 'إرسال الطلب',
  'ileri': 'التالي',
  'sozlesmeGonderildi': 'تم إرسال العقد إلى بريدك الإلكتروني!',
  'sozlesmeDesc': 'يرجى تحميل عقد شراكة INVAMED والمستندات المطلوبة المرسلة إلى بريدك الإلكتروني أدناه.',
  'tamamla': 'إكمال الطلب',
  'basvuruAlindi': 'تم استلام طلبك!',
  'basvuruAlindiDesc': 'سيراجع فريق INVAMED طلبك ويتواصل معك في أقرب وقت ممكن.',
  'Başvuru Durumu': 'حالة الطلب',
  'Başvurunuz onay sürecindedir': 'طلبك قيد المراجعة',
  'sifreSifirla': 'إعادة تعيين كلمة المرور',
  'sifreSifirlaDesc': 'أدخل بريدك الإلكتروني المسجل وسنرسل لك تعليمات إعادة تعيين كلمة المرور.',
  'gonder': 'إرسال',
  'talimatGonderildi': 'تم إرسال التعليمات',
  'sentDesc': 'تم إرسال تعليمات إعادة تعيين كلمة المرور إلى <b>{email}</b>. يرجى التحقق من بريدك الإلكتروني.',
  'helpTitle': 'كيف يمكنني تسجيل الدخول؟',
  'helpList': [
    'لتسجيل الدخول إلى لوحة موزع INVAMED، أدخل بريدك الإلكتروني المسجل وكلمة المرور.',
    'لتسجيل الدخول مع مستخدم تجريبي:',
    'إذا نسيت كلمة المرور، استخدم رابط "نسيت كلمة المرور" لطلب إعادة تعيين.',
    'إذا كانت لديك مشاكل في تسجيل الدخول، تأكد من أن بريدك الإلكتروني وكلمة المرور صحيحان. إذا استمرت المشكلة، اتصل بفريق الدعم لدينا.'
  ],
  'partnerlikSozlesmeTitle': 'عقد شراكة INVAMED والشروط',
  'partnerlikSozlesmeText': `1. الأحكام العامة

يتم إبرام هذا العقد بين INVAMED (المشار إليها فيما يلي باسم "الشركة") والمرشح الشريك (المشار إليه فيما يلي باسم "الشريك") لأغراض التعاون في بيع الأجهزة والمعدات الطبية.

2. شروط الشراكة

2.1. يجب أن يكون للشريك سلطة قانونية لبيع الأجهزة الطبية.
2.2. يجب أن يكون الشريك منظمة تعمل في مجال الرعاية الصحية.
2.3. يجب أن يكون للشريك التراخيص والشهادات المطلوبة.
2.4. يجب أن يكون الشريك موثوقاً مالياً.

3. التزامات الأطراف

التزامات الشركة:
3.1. توفير منتجات وخدمات عالية الجودة
3.2. توفير الدعم التقني
3.3. توفير التدريب والمعلومات
3.4. الشفافية في التسعير

التزامات الشريك:
3.1. تخزين المنتجات في ظروف مناسبة
3.2. توفير خدمة عملاء عالية الجودة
3.3. الامتثال للوائح القانونية
3.4. حماية العلامة التجارية للشركة

4. التسعير والدفع

4.1. يتم تحديد الأسعار من قبل الشركة
4.2. الشريك ملزم بالحفاظ على الأسعار المحددة
4.3. يتم تحديد شروط الدفع بشكل منفصل
4.4. قد تختلف معدلات العمولة حسب الأداء

5. السرية والأمان

5.1. الأطراف ملزمة بحماية المعلومات السرية لبعضها البعض
5.2. يجب الحفاظ على سرية معلومات العملاء
5.3. يجب الامتثال لمعايير أمان البيانات

6. مدة العقد والإنهاء

6.1. هذا العقد صالح لمدة سنة واحدة
6.2. يمكن تمديده بالاتفاق المتبادل
6.3. يمكن إنهاؤه بإشعار مسبق لمدة 30 يوماً
6.4. يمكن إنهاؤه فوراً في حالة الانتهاك الجسيم

7. حل النزاعات

7.1. يتم محاولة حل النزاعات في المقام الأول من خلال التفاوض
7.2. محاكم جمهورية تركيا مخولة للحالات غير المحلولة

8. الفعالية

تم قراءة وفهم وقبول هذا العقد من قبل الأطراف.`,
  'partnerlikSozlesmeOnay': 'لقد قرأت وفهمت وأوافق على عقد شراكة INVAMED والشروط أعلاه. أعلن أنني أوافق على جميع مواد هذا العقد وسأفي بالتزاماتي.',
  'sozlesmeyiGoruntule': 'عرض العقد',
  'sozlesmeyiKapat': 'إغلاق',
  'Ürün': 'المنتج',
  'Ürün eklemek için ürün listesinden seçim yapın': 'اختر من قائمة المنتجات لإضافة إلى السلة',
  'Etiketler': 'العلامات',
  'Öncelikli': 'أولوية',
  'Kapat': 'إغلاق',
  'globalPartnersTitle': 'التعاون مع 30,000 شريك حول العالم',
  'globalPartnersDesc': 'شبكتنا العالمية الواسعة المكونة من 30,000 شريك تحفز الابتكار المشترك وتبادل المعرفة والنجاح المتبادل. من خلال العمل معاً، نوسع باستمرار حدود رعاية المرضى.',
  'Yardım': 'المساعدة',
  'dil': 'اللغة',
  'Connect Free!': 'اتصل مجاناً!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'اكتشف منتجاتنا الأكثر تفضيلاً',
  'Tüm Kategoriler': 'جميع الفئات',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 منتج معروض (المجموع: 8000+)',
  'Tüm Ürünleri Gör →': 'عرض جميع المنتجات →',
  'Detaylar': 'التفاصيل',
  'Sipariş Ver': 'اطلب الآن',
  'Giriş Yap': 'تسجيل الدخول',
  'Hesabınıza giriş yapın': 'سجل الدخول إلى حسابك',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'هذا الموقع محمي بواسطة reCAPTCHA وتطبق سياسة الخصوصية وشروط الخدمة من Google.',
  'Ürün Kataloğumuz': 'كتالوج منتجاتنا',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'نحن نقدم أكثر من 8000 منتج',
  '1,3B': '1,3ألف',
  'Partner': 'شريك',
  '8,4M': '8,4مليون',
  'Toplam Üretim': 'إجمالي الإنتاج',
  '23': '23',
  'Branş': 'فرع',
  '27,5B': '27,5ألف',
  'Toplam Sipariş': 'إجمالي الطلبات',
  'Connect Now': 'اتصل الآن',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'سجل مجاناً للوصول إلى جميع المعلومات في مكان واحد.',
  'Ürün Detayları': 'تفاصيل المنتج',
  'Kapat': 'إغلاق',
  'Yükleniyor...': 'جاري التحميل...',
  'Hata': 'خطأ',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} منتج معروض (المجموع: 8000+)',
  'Şehir Seçimi': 'اختيار المدينة',
  'Firma / Sağlık Profesyoneli': 'الشركة / المتخصص الصحي',
  'Yetkili Kişi': 'الشخص المفوض',
  'Telefon': 'الهاتف',
  'E-posta': 'البريد الإلكتروني',
  'Temel Bilgiler': 'المعلومات الأساسية',
  'Ek Bilgiler': 'معلومات إضافية',
  'Faaliyet Alanı / Sektör': 'مجال النشاط / القطاع',
  'Ülke Seçimi': 'اختيار البلد',
  'Ülke adı veya kodu ara...': 'البحث عن اسم البلد أو الرمز...',
  'region.Avrupa': 'أوروبا',
  'region.Amerika': 'أمريكا',
  'region.Asya': 'آسيا',
  'region.Afrika': 'أفريقيا',
  'region.Okyanusya': 'أوقيانوسيا',
  'region.Diğer': 'أخرى',
  'country.TR': 'تركيا',
  'country.US': 'الولايات المتحدة',
  'country.DE': 'ألمانيا',
  'country.FR': 'فرنسا',
  'country.GB': 'المملكة المتحدة',
  'country.IT': 'إيطاليا',
  'country.ES': 'إسبانيا',
  'country.RU': 'روسيا',
  'country.CN': 'الصين',
  'country.JP': 'اليابان',
  'country.KR': 'كوريا الجنوبية',
  'country.IN': 'الهند',
  'country.BR': 'البرازيل',
  'country.CA': 'كندا',
  'country.AU': 'أستراليا',
  'Ticaret Sicil No': 'رقم السجل التجاري',

  'country.TR': 'تركيا',
  'country.AL': 'ألبانيا',
  'country.DE': 'ألمانيا',
  'country.AD': 'أندورا',
  'country.AT': 'النمسا',
  'country.BY': 'بيلاروسيا',
  'country.BE': 'بلجيكا',
  'country.BA': 'البوسنة والهرسك',
  'country.BG': 'بلغاريا',
  'country.CZ': 'جمهورية التشيك',
  'country.DK': 'الدنمارك',
  'country.EE': 'إستونيا',
  'country.FO': 'جزر فارو',
  'country.FI': 'فنلندا',
  'country.FR': 'فرنسا',
  'country.GI': 'جبل طارق',
  'country.GR': 'اليونان',
  'country.GG': 'غيرنزي',
  'country.HR': 'كرواتيا',
  'country.NL': 'هولندا',
  'country.IE': 'أيرلندا',
  'country.ES': 'إسبانيا',
  'country.SE': 'السويد',
  'country.CH': 'سويسرا',
  'country.IT': 'إيطاليا',
  'country.IS': 'آيسلندا',
  'country.JE': 'جيرزي',
  'country.ME': 'الجبل الأسود',
  'country.LV': 'لاتفيا',
  'country.LI': 'ليختنشتاين',
  'country.LT': 'ليتوانيا',
  'country.LU': 'لوكسمبورغ',
  'country.HU': 'المجر',
  'country.MT': 'مالطا',
  'country.IM': 'جزيرة مان',
  'country.MD': 'مولدوفا',
  'country.MC': 'موناكو',
  'country.MK': 'مقدونيا الشمالية',
  'country.NO': 'النرويج',
  'country.PL': 'بولندا',
  'country.PT': 'البرتغال',
  'country.RO': 'رومانيا',
  'country.RU': 'روسيا',
  'country.SM': 'سان مارينو',
  'country.RS': 'صربيا',
  'country.SK': 'سلوفاكيا',
  'country.SI': 'سلوفينيا',
  'country.SJ': 'سفالبارد ويان ماين',
  'country.UA': 'أوكرانيا',
  'country.GB': 'المملكة المتحدة',
  'country.VA': 'الفاتيكان',
  'country.AX': 'جزر أولاند',
  'country.US': 'الولايات المتحدة',
  'country.AS': 'ساموا الأمريكية',
  'country.AI': 'أنغويلا',
  'country.AG': 'أنتيغوا وبربودا',
  'country.AR': 'الأرجنتين',
  'country.AW': 'أروبا',
  'country.BS': 'الباهاما',
  'country.BB': 'بربادوس',
  'country.BZ': 'بليز',
  'country.BM': 'برمودا',
  'country.BO': 'بوليفيا',
  'country.BR': 'البرازيل',
  'country.VG': 'جزر العذراء البريطانية',
  'country.CA': 'كندا',
  'country.KY': 'جزر كايمان',
  'country.CL': 'تشيلي',
  'country.CO': 'كولومبيا',
  'country.CR': 'كوستاريكا',
  'country.CU': 'كوبا',
  'country.CW': 'كوراساو',
  'country.DM': 'دومينيكا',
  'country.DO': 'جمهورية الدومينيكان',
  'country.EC': 'الإكوادور',
  'country.SV': 'السلفادور',
  'country.FK': 'جزر فوكلاند',
  'country.GF': 'غويانا الفرنسية',
  'country.GD': 'غرينادا',
  'country.GL': 'غرينلاند',
  'country.GP': 'غوادلوب',
  'country.GT': 'غواتيمالا',
  'country.GY': 'غيانا',
  'country.HT': 'هايتي',
  'country.HN': 'هندوراس',
  'country.JM': 'جامايكا',
  'country.MQ': 'مارتينيك',
  'country.MX': 'المكسيك',
  'country.MS': 'مونتسيرات',
  'country.NI': 'نيكاراغوا',
  'country.PA': 'بنما',
  'country.PY': 'باراغواي',
  'country.PE': 'بيرو',
  'country.PR': 'بورتوريكو',
  'country.BL': 'سان بارتيلمي',
  'country.KN': 'سانت كيتس ونيفيس',
  'country.LC': 'سانت لوسيا',
  'country.MF': 'سانت مارتن',
  'country.PM': 'سان بيير وميكلون',
  'country.VC': 'سانت فنسنت والغرينادين',
  'country.SX': 'سينت مارتن',
  'country.SR': 'سورينام',
  'country.TT': 'ترينيداد وتوباغو',
  'country.TC': 'جزر توركس وكايكوس',
  'country.UY': 'أوروغواي',
  'country.VE': 'فنزويلا',
  'country.VI': 'جزر العذراء الأمريكية',
  'country.AF': 'أفغانستان',
  'country.AZ': 'أذربيجان',
  'country.BH': 'البحرين',
  'country.BD': 'بنغلاديش',
  'country.AE': 'الإمارات العربية المتحدة',
  'country.BN': 'بروناي',
  'country.BT': 'بوتان',
  'country.CN': 'الصين',
  'country.TL': 'تيمور الشرقية',
  'country.ID': 'إندونيسيا',
  'country.AM': 'أرمينيا',
  'country.PH': 'الفلبين',
  'country.PS': 'فلسطين',
  'country.GE': 'جورجيا',
  'country.KR': 'كوريا الجنوبية',
  'country.IN': 'الهند',
  'country.HK': 'هونغ كونغ',
  'country.IQ': 'العراق',
  'country.IR': 'إيران',
  'country.IL': 'إسرائيل',
  'country.JP': 'اليابان',
  'country.KH': 'كمبوديا',
  'country.QA': 'قطر',
  'country.KZ': 'كازاخستان',
  'country.KG': 'قيرغيزستان',
  'country.CY': 'قبرص',
  'country.KW': 'الكويت',
  'country.KP': 'كوريا الشمالية',
  'country.LA': 'لاوس',
  'country.LB': 'لبنان',
  'country.MO': 'ماكاو',
  'country.MV': 'جزر المالديف',
  'country.MY': 'ماليزيا',
  'country.MM': 'ميانمار',
  'country.MN': 'منغوليا',
  'country.NP': 'نيبال',
  'country.UZ': 'أوزبكستان',
  'country.PK': 'باكستان',
  'country.SG': 'سنغافورة',
  'country.LK': 'سريلانكا',
  'country.SY': 'سوريا',
  'country.SA': 'المملكة العربية السعودية',
  'country.TJ': 'طاجيكستان',
  'country.TH': 'تايلاند',
  'country.TW': 'تايوان',
  'country.TM': 'تركمانستان',
  'country.OM': 'عمان',
  'country.JO': 'الأردن',
  'country.VN': 'فيتنام',
  'country.YE': 'اليمن',
  'country.DZ': 'الجزائر',
  'country.AO': 'أنغولا',
  'country.BJ': 'بنين',
  'country.BW': 'بوتسوانا',
  'country.BF': 'بوركينا فاسو',
  'country.BI': 'بوروندي',
  'country.CV': 'الرأس الأخضر',
  'country.CM': 'الكاميرون',
  'country.CF': 'جمهورية أفريقيا الوسطى',
  'country.TD': 'تشاد',
  'country.KM': 'جزر القمر',
  'country.CG': 'جمهورية الكونغو',
  'country.CD': 'جمهورية الكونغو الديمقراطية',
  'country.CI': 'ساحل العاج',
  'country.DJ': 'جيبوتي',
  'country.EG': 'مصر',
  'country.GQ': 'غينيا الاستوائية',
  'country.ER': 'إريتريا',
  'country.SZ': 'إسواتيني',
  'country.ET': 'إثيوبيا',
  'country.GA': 'الغابون',
  'country.GM': 'غامبيا',
  'country.GH': 'غانا',
  'country.GN': 'غينيا',
  'country.GW': 'غينيا بيساو',
  'country.KE': 'كينيا',
  'country.LS': 'ليسوتو',
  'country.LR': 'ليبيريا',
  'country.LY': 'ليبيا',
  'country.MG': 'مدغشقر',
  'country.MW': 'ملاوي',
  'country.ML': 'مالي',
  'country.MR': 'موريتانيا',
  'country.MU': 'موريشيوس',
  'country.YT': 'مايوت',
  'country.MA': 'المغرب',
  'country.MZ': 'موزمبيق',
  'country.NA': 'ناميبيا',
  'country.NE': 'النيجر',
  'country.NG': 'نيجيريا',
  'country.RE': 'ريونيون',
  'country.RW': 'رواندا',
  'country.SH': 'سانت هيلينا',
  'country.ST': 'ساو تومي وبرينسيبي',
  'country.SN': 'السنغال',
  'country.SC': 'سيشل',
  'country.SL': 'سيراليون',
  'country.SO': 'الصومال',
  'country.ZA': 'جنوب أفريقيا',
  'country.SS': 'جنوب السودان',
  'country.SD': 'السودان',
  'country.TZ': 'تنزانيا',
  'country.TG': 'توغو',
  'country.TN': 'تونس',
  'country.UG': 'أوغندا',
  'country.EH': 'الصحراء الغربية',
  'country.ZM': 'زامبيا',
  'country.ZW': 'زيمبابوي',
  'country.AU': 'أستراليا',
  'country.CX': 'جزيرة عيد الميلاد',
  'country.CC': 'جزر كوكوس',
  'country.CK': 'جزر كوك',
  'country.FJ': 'فيجي',
  'country.PF': 'بولينيزيا الفرنسية',
  'country.GU': 'غوام',
  'country.HM': 'جزيرة هيرد وجزر ماكدونالد',
  'country.KI': 'كيريباتي',
  'country.MH': 'جزر مارشال',
  'country.FM': 'ميكرونيزيا',
  'country.NR': 'ناورو',
  'country.NC': 'كاليدونيا الجديدة',
  'country.NZ': 'نيوزيلندا',
  'country.NU': 'نيوي',
  'country.NF': 'جزيرة نورفولك',
  'country.MP': 'جزر ماريانا الشمالية',
  'country.PW': 'بالاو',
  'country.PG': 'بابوا غينيا الجديدة',
  'country.PN': 'جزر بيتكيرن',
  'country.WS': 'ساموا',
  'country.SB': 'جزر سليمان',
  'country.TK': 'توكيلاو',
  'country.TO': 'تونغا',
  'country.TV': 'توفالو',
  'country.VU': 'فانواتو',
  'country.WF': 'واليس وفوتونا',
  'country.AQ': 'أنتاركتيكا',
  'country.BV': 'جزيرة بوفيه',
  'country.IO': 'إقليم المحيط الهندي البريطاني',
  'country.TF': 'الأراضي الفرنسية الجنوبية',
  'country.GS': 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
};
